import { getCouponCode } from './getCouponCode';
import { getIsDiy } from './getIsDiy';

import type { Attribute, AttributesContextualInfo } from '../types';

type AttributeGetter = (
  context: AttributesContextualInfo
) => SplitIO.AttributeType;

const ATTRIBUTE_GETTERS = {
  pcode: getCouponCode,
  isDiy: getIsDiy,
} as const satisfies Record<Attribute, AttributeGetter>;

export function getAttributeValue(
  attribute: Attribute,
  context: AttributesContextualInfo
): SplitIO.AttributeType {
  return ATTRIBUTE_GETTERS[attribute](context);
}
